import type { TranslationInterface } from '.';

export const PolishLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Napisz wiadomość...',
  your_issue_has_been_resolved: 'Twój problem został rozwiązany!',
  new_conversation: 'Nowa rozmowa',
  welcome_screen_title: 'Witamy w naszym czacie wsparcia',
  welcome_screen_description:
    'Jesteśmy tutaj, aby pomóc! Rozpocznij rozmowę, a odpowiemy jak najszybciej.',
  your_name_placeholder: 'Twoje imię',
  your_email_placeholder: 'Twój adres email',
  start_chat_button: 'Porozmawiaj ze wsparciem',
  start_chat_button_loading: 'Łączenie...',
  i_need_more_help: 'Potrzebuję więcej pomocy',
  this_was_helpful: 'To było pomocne',
  optional: 'Opcjonalne',
  no_conversations_yet: 'Jeszcze brak rozmów',
  back_to_conversations: 'Powrót do rozmów',
  closed_conversations: 'Zamknięte rozmowy',
  csat_title: 'Jak przebiegła Twoja rozmowa?',
  csat_submitted_title: 'Oceniłeś rozmowę jako',
  csat_feedback_placeholder: 'Powiedz nam więcej... (opcjonalnie)',
  follow_up_placeholder: 'Dopytaj…',
  companion_layout_label: 'Układ',
  companion_layout_floating: 'Pływający',
  companion_layout_sidebar: 'Pasek boczny',
  companion_layout_fullscreen: 'Pełny ekran',
  companion_close: 'Zamknij',
  companion_history: 'Historia rozmów',
  companion_expand_chat: 'Rozwiń czat',
  companion_sidebar_dock_label: 'Dokowanie',
  companion_sidebar_side_label: 'Strona',
  companion_sidebar_left: 'Lewa',
  companion_sidebar_right: 'Prawa',
  companion_resize_chat: 'Zmień rozmiar czatu',
  scroll_to_bottom: 'Przewiń na dół',
  thinking: 'Myślę…',
  running: 'W toku…',
  steps: 'kroki',
  step_arguments: 'Argumenty',
  step_result: 'Wynik',
  attach_files:
    'Dołącz obrazy, filmy, pliki PDF lub arkusze kalkulacyjne (maksymalny rozmiar 25 MB)',
  mark_page_active:
    'Kliknij coś na stronie, aby to oznaczyć — Esc, aby anulować',
  mark_page: 'Oznacz coś na stronie, aby o to zapytać',
  stop_response: 'Zatrzymaj odpowiedź',
  copy_reply: 'Kopiuj odpowiedź',
  mentions_empty: 'Brak wyników',
  copied: 'Skopiowano',
  send_message: 'Wyślij wiadomość',
  upload_failed: 'Przesyłanie nie powiodło się: {error}',
  remove_attachment: 'Usuń załącznik',
  json_no_items: 'Brak elementów',
  json_no_data: 'Brak danych',
  json_no_chart_data: 'Brak danych do wykresu',
  json_unsupported: 'Nieobsługiwane: {type}',
  json_see_less: 'Pokaż mniej',
  json_phone_agent: 'Agent telefoniczny',
  json_phone_agent_test: 'Przetestuj w sieci',
  page_context_remove: 'Usuń kontekst strony',
  json_see_more: 'Pokaż jeszcze {count}',
  queued_label: '{count} W kolejce',
  remove_queued_message: 'Usuń wiadomość z kolejki',
  send_queued_now: 'Wyślij wiadomości z kolejki teraz',
  turn_failed_message: 'Coś poszło nie tak i odpowiedź nie dotarła.',
  turn_failed_retry: 'Spróbuj ponownie',
  page_mark_hint: 'Kliknij coś, aby to oznaczyć',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Ramka',
  page_mark_shape_circle: 'Okrąg',
  page_mark_shape_arrow: 'Strzałka',
  page_mark_shape_bracket: 'Nawias',
  page_mark_shape_underline: 'Podkreślenie',
  page_mark_shape_highlight: 'Wyróżnienie',
  page_mark_shape_strike_through: 'Przekreślenie',
  page_mark_shape_crossed_off: 'Skreślenie krzyżykiem',
  page_mark_shape_aria: 'Kształt oznaczenia: {shape}',
  page_mark_note_placeholder: 'Dodaj notatkę… (Enter, aby dołączyć)',
  page_mark_attach: 'Dołącz oznaczenie',
  page_mark_remove: 'Usuń {label}',
  page_mark_region: 'Oznaczony obszar',
  page_mark_default_message: 'Co to jest?',
  file_rejected: 'Typ pliku nie jest obsługiwany lub plik jest za duży.',
  dictate: 'Dyktuj',
  stop_dictation: 'Zatrzymaj dyktowanie',
  dictation_mic_blocked: 'Zezwól na dostęp do mikrofonu, aby dyktować',
  dictation_unavailable: 'Dyktowanie jest obecnie niedostępne',
  questions_back: 'Wstecz',
  questions_next: 'Dalej',
  questions_send: 'Wyślij',
  questions_type_answer: 'Napiszę sam',
  questions_answer_placeholder: 'Wpisz swoją odpowiedź…',
  close_conversation_title: 'Zamknij rozmowę',
  close_conversation_description: 'Czy na pewno chcesz zamknąć tę rozmowę?',
  close_conversation_cancel: 'Nie',
  close_conversation_confirm: 'Tak',
  dialog_close: 'Zamknij',
  zoom_in: 'Powiększ',
  zoom_out: 'Pomniejsz',
  reset_zoom: 'Resetuj powiększenie',
  support_chat_aria_label: 'Czat pomocy',
};
